import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["spinner", "rescheduleForm"]

  connect() {
    this.pollUrl = null
    this.poller = null
    this.startActivation()
    this.poller = setInterval(() => this.poll(), 2000)
  }

  disconnect() {
    if (this.poller) {
      clearInterval(this.poller)
      this.poller = null
    }
  }

  startActivation() {
    const url = this.data.get("activate-url")
    const payload = this.data.get("sign-up-data")
    const token = document.querySelector('meta[name="csrf-token"]')?.content

    $.ajax({
      url,
      method: "POST",
      data: { accounts_sign_up: { data: payload } },
      headers: token ? { "X-CSRF-Token": token } : {},
    }).done((data, textStatus, jqXHR) => {
      this.pollUrl = jqXHR.getResponseHeader("location")
    })
  }

  poll() {
    if (!this.pollUrl) return

    fetch(this.pollUrl)
      .then((response) => {
        if (response.redirected) {
          clearInterval(this.poller)
          this.poller = null
          window.location = response.url
        } else if (response.status === 422) {
          clearInterval(this.poller)
          this.poller = null
          return response.json()
        }
      })
      .then((json) => {
        if (!json) return

        let errs = json["base"]
        if (!Array.isArray(errs)) {
          errs = [errs]
        }

        const extraSignUp = this.data.get("extra-sign-up-error")
        const doubleBooking = this.data.get("double-booking-error")
        const transactionDeclined = this.data.get("transaction-declined-error")
        const resubmitPayment = this.data.get("resubmit-payment-error")

        if (errs.includes(extraSignUp)) {
          window.location = this.data.get("no-changes-allowed-url")
          return
        }
        if (errs.includes(doubleBooking)) {
          alert(doubleBooking)
          $(this.rescheduleFormTarget).submit()
          return
        }
        if (errs.includes(transactionDeclined)) {
          alert(transactionDeclined)
          window.history.back()
          return
        }
        if (errs.includes(resubmitPayment)) {
          alert(resubmitPayment)
          window.history.back()
          return
        }

        const customerService = this.data.get("customer-service-phone")
        const msg = `<h5 class='mt-5'>An error occurred while placing your order. Please call Customer Service at ${customerService}.</h5>`
        const backLink = "<a href='javascript:history.back()'>Back</a>"
        const html = `<div class="col"><div class="row"><div class="col">${msg}</div></div><div class="row"><div class="col">The error was:<br/><h6>${errs}</h6></div></div><div class="row"><div class="col">${backLink}</div></div></div>`
        $(this.spinnerTarget).replaceWith(html)
      })
      .catch((error) => {
        console.error("Error:", error)
      })
  }
}
